import { CreditCardType } from 'generated/graphql';



/**

 * Maps card brand from the payment terminal to MenuX display labels.

 * These labels match creditCardEnum() in BillSettlement.tsx.

 */

export function mapCardBrandToMenuXLabel(

	cardBrand?: string | null,

): string | null {

	const enumValue = mapCardBrandToCreditCardType(cardBrand);

	if (!enumValue) return null;



	const labelByEnum: Record<CreditCardType, string> = {

		[CreditCardType.VisaCard]: 'Visa Card',

		[CreditCardType.Mastercard]: 'Master Card',

		[CreditCardType.AmericanExpressCard]: 'American Express Card',

		[CreditCardType.DinersCard]: 'Diners Card',

		[CreditCardType.JcbCard]: 'JCB Card',

		[CreditCardType.UnionpayCard]: 'UNION PAY',

		[CreditCardType.DebitCard]: 'Debit Card',

		[CreditCardType.Ewallet]: 'E-Wallet',

	};



	return labelByEnum[enumValue] ?? null;

}



/**

 * Maps terminal card brand (e.g. "Visa Debit", "MASTERCARD") to GraphQL CreditCardType.

 * MenuX stores enum values such as DEBIT_CARD / VISA_CARD — not display strings.

 */

export function mapCardBrandToCreditCardType(

	cardBrand?: string | null,

): CreditCardType | null {

	if (!cardBrand) return null;



	const raw = String(cardBrand).trim();

	if (!raw) return null;



	if (Object.values(CreditCardType).includes(raw as CreditCardType)) {

		return raw as CreditCardType;

	}



	const normalized = raw.toLowerCase();



	// "Visa Debit" on receipt — treat as debit before generic visa

	if (

		normalized.includes('debit') ||

		normalized.includes('mydebit') ||

		normalized.includes('visa debit')

	) {

		return CreditCardType.DebitCard;

	}

	if (normalized.includes('visa')) return CreditCardType.VisaCard;

	if (normalized.includes('master')) return CreditCardType.Mastercard;

	if (normalized.includes('amex') || normalized.includes('american')) {

		return CreditCardType.AmericanExpressCard;

	}

	if (normalized.includes('jcb')) return CreditCardType.JcbCard;

	if (normalized.includes('diner')) return CreditCardType.DinersCard;

	if (normalized.includes('union')) return CreditCardType.UnionpayCard;

	if (normalized.includes('wallet') || normalized.includes('ewallet')) {

		return CreditCardType.Ewallet;

	}



	return null;

}


